import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import { plural_entity_reference_revisions_paragraph_with_target_node_event_field_paragraphs_parser } from "../api/drupal/parser";
import { Blocks } from "../features/blocks";
const draftToHtml = require("draftjs-to-html");
const React = require("react");
const MarkdownIt = require('markdown-it');
export const Text = (props)=>{
    if (!props) return /*#__PURE__*/ _jsx(_Fragment, {});
    switch(props.MarkUp){
        case 'plaintext':
            return PlainText(props);
        case 'html':
            return HTML(props);
        case 'draftjs':
            return DraftJS(props);
        case 'blocks':
            return BlocksFromRaw(props.Content);
        case 'markdown':
            return Markdown(props);
        default:
            throw new Error(`The markup type ${props.MarkUp} is not (yet) supported`);
    }
};
const PlainText = (props)=>/*#__PURE__*/ _jsx("div", {
        className: `plaintext-block ${props.className || ''}`,
        children: props.Content
    });
const HTML = (props)=>/*#__PURE__*/ _jsx("div", {
        className: `richtext-block text--styled ${props.className || ''}`,
        dangerouslySetInnerHTML: {
            __html: props.Content
        }
    });
const DraftJS = (props)=>/*#__PURE__*/ _jsx("div", {
        className: `richtext-block text--styled ${props.className || ''}`,
        dangerouslySetInnerHTML: {
            __html: draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(JSON.parse(props.Content))).getCurrentContent()))
        }
    });
const BlocksFromRaw = (rawParagraphs)=>{
    const obj = JSON.parse(rawParagraphs);
    const blocks = plural_entity_reference_revisions_paragraph_with_target_node_event_field_paragraphs_parser(obj);
    return /*#__PURE__*/ _jsx(Blocks, {
        blocks
    });
};
const md = MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true
});
const Markdown = (props)=>{
    // The Olifantenpaadje WYSIWYG editor somehow allows bold passages to end in a whitespace character,
    // which is not standard Markdown practice. This piece of regex cleans up these occurences.
    // Matches any phrase surrounded by two pairs of asterisks '**', where:
    const phraseWithAsterisks = /\*\*.*?\*\*/g;
    // Given phraseWithAsterisks, replace any trailing whitespace before the last '**' with just '**'.
    const processed = props.Content.replace(phraseWithAsterisks, (match)=>match.replace(/\s+\*\*$/, '**'));
    return /*#__PURE__*/ _jsx("div", {
        className: `text--styled ${props.className || ''}`,
        dangerouslySetInnerHTML: {
            __html: md.render(processed)
        }
    });
};
